<template>
  <div class="flex flex-wrap mt-3 -mx-3">
    <div class="w-full md:w-1/2 px-3 mb-3 md:mb-2">
      <slot name="first"/>
    </div>
    <div class="w-full md:w-1/2 px-3 mb-3 md:mb-2">
      <slot name="second"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutTwoColumn"
}
</script>

<style scoped>

</style>
